import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00b9ad', // fsTeal
      light: '#5bebdf',
      dark: '#00897f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#007a9a', // darkBlue
      light: '#4fa9cb',
      dark: '#004e6c',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5', // navBarBackground light
      paper: '#ffffff',
    },
    text: {
      primary: '#262626', // mainText
      secondary: 'rgba(38, 38, 38, 0.7)',
    },
    error: {
      main: '#ff3131', // redBackground approximation
    },
    warning: {
      main: '#ffa500', // orangeBackground approximation
    },
    info: {
      main: '#4fa9bb', // middleBlue
    },
    success: {
      main: '#00b9ad', // Using fsTeal for success
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '1rem',
        },
        containedPrimary: {
          background: 'linear-gradient(45deg, #00b9ad 30%, #5bebdf 90%)',
          boxShadow: '0 3px 5px 2px rgba(0, 185, 173, .3)',
          '&:hover': {
            background: 'linear-gradient(45deg, #00897f 30%, #4fa9cb 90%)',
          },
          // The gradient is a background-image, and MUI's disabled style only
          // sets background-color, so without clearing it here a disabled
          // button keeps the full-strength teal gradient and its greyed label
          // reads as unreadable dark teal.
          '&.Mui-disabled': {
            background: 'none',
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;